/**
 * RP → SP3 conversion quota by member level (§8.3).
 * Total quota per level; remaining = quota − rp_sp3_converted on user row.
 */
import { USER_LEVELS } from './levels.js';

/** Default quota when level_code is missing from map. */
export const RP_SP3_QUOTA_DEFAULT = '0';

/**
 * Per-level RP→SP3 conversion cap (USD/R P units, 1:1 with SP3).
 * Align with line网 php_uo_config when mirrored; E3 example = 9000 in App tips.
 */
export const RP_SP3_QUOTA_BY_LEVEL: Record<string, string> = {
  E1: '1000',
  E2: '3000',
  E3: '9000',
  A1: '9000',
  A2: '10000',
  A3: '12000',
  A4: '15000',
  A5: '18000',
  S1: '10000',
  S2: '20000',
  S3: '30000',
  S4: '40000',
  S5: '50000',
  S6: '60000',
  S7: '70000',
  S8: '80000',
  S9: '90000',
};

export function resolveRpSp3Quota(levelCode: string): string {
  return RP_SP3_QUOTA_BY_LEVEL[levelCode] ?? RP_SP3_QUOTA_DEFAULT;
}

/** All level codes that have a defined quota (for admin docs). */
export const RP_SP3_QUOTA_LEVEL_CODES = USER_LEVELS.map((l) => l.code);
